'use client';

import dynamic from 'next/dynamic';
import { isTest } from '~/constants/environment';

const FeatureBranch = dynamic(
  () =>
    import(
      /* webpackChunkName: "FeatureBranch" */ '@/common/FeatureBranch/appRouter'
    ),
  { ssr: false }
);

export default function AppFeatureBranch() {
  if (!isTest) {
    return null;
  }

  return <FeatureBranch />;
}
